import React from "react";
import "./App.css";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import Home from "./pages/Home";
import Layout from "./Layout";
import Login from "./pages/Login";
import OrderItems from "./pages/OrderItems";
import LogoDefaultConfig from "./pages/LogoDefaultConfig";
import {AuthProvider, useAuth} from "./AuthContext";
import PrivateRoute from "./PrivateRoute";

function App() {


    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route path="/" element={<Layout/>}>
                        <Route path="/" element={<Navigate to="/login" replace={true}/>}/>
                        <Route path="/login" element={<Login/>}/>
                        
                        
                        <Route path="/orders" element={   <PrivateRoute><Home/></PrivateRoute>}/>
                        <Route path="/config" element={ <PrivateRoute><LogoDefaultConfig/></PrivateRoute>}/>
                        <Route path="/orders/items" element={ <PrivateRoute><OrderItems/></PrivateRoute>}/>
                        <Route path="/orders/modal/:id" element={<Home/>}/>
                        <Route path="/config" element={<LogoDefaultConfig/>}/>
                        <Route path="/logout"/>
                        <Route path="*" element={<Navigate to="/login" replace={true}/>}/>
                    </Route>
                </Routes>
            </AuthProvider>

        </BrowserRouter>
    );
}

export default App;
